
import { defineComponent } from 'vue';

import YourDataForm from '@/components/YourDataForm/YourDataForm.vue';
import ProgressIndicator from '@/components/ProgressIndicator/ProgressIndicator.vue';
import PoweredBy from '@/components/PoweredBy/PoweredBy.vue';
import { FormRow } from 'mq-ui-kit/lib/FormRow';

export default defineComponent({
  name: 'YourData',

  components: {
    YourDataForm,
    ProgressIndicator,
    PoweredBy,
    FormRow,
  },
});
